import { combineReducers } from "redux";
import authenticationReducer from "./authenticationReducer"; 
import travelerReducer from "./travelerReducer"; 
import commonReducer from "./commonReducer"; 
import homeReducer from "./homeReducer"; 
import senderReducer from "./senderReducer"; 
import aboutReducer from "./aboutReducer"; 
import howItWorkReducer from "./howItWorkReducer"; 

const rootReducer = combineReducers({
  auth: authenticationReducer,
  travelerData: travelerReducer,
  contactData: commonReducer,
  cityData: commonReducer,
  homePageData: homeReducer,
  senderPageData: senderReducer,
  travelerPageData: travelerReducer,
  aboutPageData: aboutReducer,
  howItWorksPageData: howItWorkReducer,
   
});

export default rootReducer;
